/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-content-spacer[_ngcontent-%COMP%]{margin-left:10px}.navbar-placeholder[_ngcontent-%COMP%]{margin-top:20px;height:44px}.checkbox-wrapper[_ngcontent-%COMP%]{padding:10px 20px}@media (min-width:768px){.checkbox-wrapper[_ngcontent-%COMP%]{padding:0}}.official-answers-disclaimer[_ngcontent-%COMP%]{padding:10px;margin-top:30px;font-size:13px}.official-answers-disclaimer[_ngcontent-%COMP%]::before{content:'*'}"];
export { styles as styles };
